<template>
  <div>
    <top-part :rightPart="true" @backTo="backTo">
      <template slot="difinePort">
        <div class="complete-button" @click.stop="completeBtn">完成</div>
      </template>
    </top-part>
    <div class="my-content">
      <gridDrag :menuList="authorityInfoWx" @delItem="delAttr" @changeDrag="changeItem"></gridDrag>
      <home-grid :menuList="getAllMenuAPPattr" @addItem="addAttr" :stusConfig="startConfig"></home-grid>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/headerBar";
import homeGrid from "./components/gridEdit";
import gridDrag from "./components/gridDrag";
import interfaceAttr from "../../centralControl/utils/interfaceAttr";
export default {
  components: {
    topPart,
    homeGrid,
    gridDrag
  },
  data() {
    return {
      authorityInfoWx: [
        {
          menu_name: `常用服务<div class="name-text">(常用服务的应用展示在首页，拖动可排序)</div>`,
          list: []
        }
      ],
      getUserIdMenuAPPAttr: [], //接收用户菜单数据
      getAllMenuAPPattr: [], //获取全部菜单
      interAttrs: ["getUserIdMenuAPP", "getAllMenuAPP"], //需要请求的接口名称
      comleteParam: {
        //保存用户菜单
        interfaceName: "saveUserIdMenuAPP",
        params: {},
        flag: false
      },
      operatingFlag: false, // 判读常用服务是否被操作
      startConfig: {} //获取权限配置
    };
  },
  watch: {
    getUserIdMenuAPPAttr(newName, oldName) {
      this.authorityInfoWx[0].list = newName;
    }
    // getAllMenuAPPattr(newName, oldName) {}
  },
  created() {
    this.init();
    console.log(this.getAllMenuAPP);
    this.startConfig = this.centralControl.utils.getConfig(
      this.centralControl.config,
      ["allItem", "manageErea"]
    );
  },
  methods: {
    // 返回方法
    backTo() {
      if (this.operatingFlag) {
        this.dialogFnConfirm("信息还未保存，确认返回吗？");
        return;
      }
      this.$router.go(-1);
    },
    dialogFnConfirm(tip) {
      this.$createDialog({
        type: "confirm",
        title: "提示",
        content: tip,
        confirmBtn: {
          text: "确定",
          active: true,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          this.$router.go(-1);
        }
      }).show();
    },
    // 结束拖拽完成后的items
    changeItem(data) {
      var dragData = JSON.parse(JSON.stringify(data));
      this.getUserIdMenuAPPAttr = dragData;
      this.operatingFlag = true;
      let contentBox = document.getElementsByClassName("my-content")[0];
      contentBox.style.overflow = "hidden";
      setTimeout(() => {
        contentBox.style.overflow = "auto";
      }, 1000);
      console.log(this.getUserIdMenuAPPAttr);
    },
    // 点击完成按钮
    completeBtn() {
      let menuCode = this.getCode(this.getUserIdMenuAPPAttr);
      const { interfaceName, params, flag } = this.comleteParam;
      this.comleteParam.params = { menuCode: menuCode };
      this.centralControl.utils.getDataIndex(
        this,
        this.comleteParam.params,
        interfaceName,
        flag
      );
    },
    saveUserIdMenuAPP(data) {
      toast(this, "保存成功", "success");
      setTimeout(() => {
        this.$router.push({ path: "/homeZhyf" });
      }, 2000);
    },
    // 获取常用服务的menuCode
    getCode(attr) {
      let strCode = "";
      for (let item in attr) {
        strCode += `${attr[item].menu_code},`;
      }
      strCode = strCode.length > 0 && strCode.substring(0, strCode.length - 1);
      return strCode;
    },
    getAllMenuAPP(data) {
      this.getAllMenuAPPattr = data;
      this.checkItems(this.getAllMenuAPPattr, this.getUserIdMenuAPPAttr);
    },
    getUserIdMenuAPP(data) {
      this.getUserIdMenuAPPAttr = data;
      this.checkItems(this.getAllMenuAPPattr, data);
    },
    // 查看全部服务的item有没有在常用服务，否则置灰为不可点击的状态
    checkItems(attrfirst, attrSecond) {
      for (let items of attrfirst) {
        for (let child in items.list) {
          let childAll = items.list[child];
          this.$set(childAll, "ashFlag", 0);
          attrSecond.filter(item => {
            if (item.menu_code === childAll.menu_code) {
              if (item.ashFlag == 2) {
                this.$set(childAll, "ashFlag", item.ashFlag);
              } else {
                this.$set(childAll, "ashFlag", 1);
              }
            }
          });
        }
      }
      console.log(attrfirst);
    },
    init() {
      this.centralControl.utils.eachIndexattr(
        this,
        this.interAttrs,
        interfaceAttr
      );
    },
    // 处理子组件传递过来要添加到常用服务的item
    addAttr(item) {
      var objItem = JSON.parse(JSON.stringify(item));
      this.$set(objItem, "ashFlag", 2);
      this.authorityInfoWx[0].list.push(objItem);
      this.origalDate(this.getAllMenuAPPattr, objItem, 1);
      this.operatingFlag = true;
    },
    // 处理子组件传递过来从常用服务删除的item
    delAttr(item) {
      var objItem = JSON.parse(JSON.stringify(item));
      if (this.getUserIdMenuAPPAttr.length <= 3) {
        toast(this, "最少保留3个应用!", "error");
        return;
      }
      this.operatingFlag = true;
      this.getUserIdMenuAPPAttr.splice(
        this.getUserIdMenuAPPAttr.findIndex(
          item => item.menu_code === objItem.menu_code
        ),
        1
      );
      this.origalDate(this.getAllMenuAPPattr, objItem, 0);
    },
    // 处理原数据  数据参数说明 自定义ashFlag字段  0:可添加，1：置灰态 2：可减少
    origalDate(attr, addi, addParam) {
      for (let item of attr) {
        for (let i in item.list) {
          if (item.list[i].menu_code == addi.menu_code) {
            this.$set(item.list[i], "ashFlag", addParam);
          }
        }
      }
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/reset.css';

.complete-button {
  margin: auto 16px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #29BEBC;
}

.top-box {
  justify-content: space-between;
}
</style>